import { Stack } from "@chakra-ui/react";
import { Card } from "@components/ui-kit";
import { t } from "@lingui/macro";
import { getSvgSpriteName } from "@src/utils/svg-sprite-name";
import { Step as StepCmp, Steps } from "chakra-ui-steps";
import { observer } from "mobx-react-lite";
import { useInvoiceStore } from "../../store";
import { Summary } from "./Summary";

const CheckIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} aria-label={t`Check icon`}>
    <use href={`/${getSvgSpriteName()}#line-check`} />
  </svg>
);

export const SideNav = observer(function SideNav() {
  const store = useInvoiceStore();

  return (
    <Stack pos="sticky" top="24" spacing="4">
      <Card pt="6" pb="2" px="4">
        <Steps
          // errorIcon={HiOutlineX}
          colorScheme="blue"
          checkIcon={CheckIcon}
          orientation="vertical"
          state={store.hasCurrentStepErrors ? "error" : undefined}
          activeStep={store.currentStepIndex}
          onClickStep={(index: number) => store.goToStep(index)}
        >
          {store.steps.map(({ label, id }) => (
            <StepCmp label={label} key={id} />
          ))}
        </Steps>
      </Card>
      <Summary />
    </Stack>
  );
});
